import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { Fragment, FunctionComponent, useState } from 'react';
import './PageProgressIndicator.scss';
import PageProgressIndicatorItem from './PageProgressIndicatorItem/PageProgressIndicatorItem';
import PageProgressLine from './PageProgressLine/PageProgressLine';

export interface IPageProgressIndicatorProps {
  progressLabels: string[];
  currentPage: number;
  className?: ClassName;
}

const PageProgressIndicator: FunctionComponent<IPageProgressIndicatorProps> = (props) => {
  const { className, progressLabels, currentPage } = props;

  const classes = classNames(
    {
      'page-progress-indicator': true,
    },
    className
  );

  function renderProgressIndicator() {
    return progressLabels.map((label, index) => {
      if (index < progressLabels.length - 1) {
        return (
          <Fragment key={index}>
            <PageProgressIndicatorItem
              animate={index !== 0}
              label={label}
              isHighlighted={currentPage > index}
              isCurrent={index + 1 === currentPage}
            />
            {/* Progress line doesn't fill up until the following circle is highlighted */}
            <PageProgressLine isHighlighted={currentPage - 1 > index} />
          </Fragment>
        );
      } else {
        return (
          <PageProgressIndicatorItem
            animate={index !== 0}
            key={index + label}
            label={label}
            isHighlighted={currentPage > index}
            isCurrent={index + 1 === currentPage}
          />
        );
      }
    });
  }

  return <div className={classes}>{renderProgressIndicator()}</div>;
};

export default PageProgressIndicator;
